import { Layout, Theme } from '~models/contentful';

/**
 * First letter is top padding, second letter is bottom padding. 's' for small, 'l' for large.
 */
export type ContentBlockPadding = 'ss' | 'll' | 'sl' | 'ls' | '';

type ContentBlockType = Record<string, unknown> & {
  theme?: Theme | null;
  blockLayout?: Layout | null;
};

/**
 * Calculates the top and bottom padding of every content block.
 * Adjacent blocks with the same theme need to have smaller padding between each other
 * otherwise the visual gap looks way too large.
 */
export const getContentBlockPaddings = (blocks: ContentBlockType[]) => {
  return (
    blocks
      // For the correct calculation all boxed blocks should be treated as a light-themed component
      .map<ContentBlockType['theme']>(({ theme, blockLayout }) => (blockLayout === 'boxed' ? 'neutral-white' : theme))
      .map<ContentBlockType['theme']>((theme) => (theme === 'light' ? 'neutral-white' : theme))
      .reduce<Record<string, ContentBlockPadding>>((paddings, theme, i, arr) => {
        if (!theme) {
          paddings[i] = '';
        } else if (arr.length === 1) {
          paddings[i] = 'ss';
        } else if (i === 0) {
          if (arr[i + 1] === theme) paddings[i] = 'ss';
          else paddings[i] = 'sl';
        } else if (i === arr.length - 1) {
          if (arr[i - 1] === theme) paddings[i] = 'ss';
          else paddings[i] = 'ls';
        } else if (arr[i - 1] === theme) {
          if (arr[i + 1] === theme) paddings[i] = 'ss';
          else paddings[i] = 'sl';
        } else if (arr[i - 1] !== theme) {
          if (arr[i + 1] === theme) paddings[i] = 'ls';
          else paddings[i] = 'll';
        }
        return paddings;
      }, {})
  );
};
